import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL, authFetch } from "../../utils/auth";
import "../../../css/partner/OnboardingWelcome.css";

const PROJECT_AMOUNT = 3000;
const PAYMENT_AMOUNT = 1500;

function money(value) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value);
}

function percent(value) {
  const numeric = Number(value || 0);
  return `${Number.isInteger(numeric) ? numeric.toFixed(0) : numeric.toFixed(2).replace(/0+$/, "").replace(/\.$/, "")}%`;
}

export default function OnboardingRole() {
  const navigate = useNavigate();
  const [commissionRate, setCommissionRate] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    async function loadCompensation() {
      try {
        const response = await authFetch(`${API_URL}/partner/onboarding/`);
        const data = await response.json();
        if (!response.ok) throw new Error(data.detail || "Unable to load compensation details.");
        if (active) setCommissionRate(data.compensation?.commission_rate || null);
      } catch (err) {
        if (active) setError(err.message || "Unable to load compensation details.");
      }
    }
    loadCompensation();
    return () => { active = false; };
  }, []);

  const example = useMemo(() => {
    const rate = Number(commissionRate || 0);
    const firstPayment = Math.round(PAYMENT_AMOUNT * (rate / 100));
    const finalPayment = Math.round(PAYMENT_AMOUNT * (rate / 100));
    return { firstPayment, finalPayment, total: firstPayment + finalPayment };
  }, [commissionRate]);

  return (
    <div className="onboarding-role">
      <h1>Your Role & Commission Structure</h1>

      <h3>Your Responsibilities</h3>

      <ul>
        <li>Identify businesses that need a website.</li>
        <li>Network online and in your community.</li>
        <li>Submit leads through the Partner Portal.</li>
        <li>Stay in contact with your referrals.</li>
      </ul>

      <h3>How You Get Paid</h3>

      <p>
        This is a <strong>commission-only opportunity</strong>.
      </p>

      <p>
        You earn commissions when clients you refer make payments toward their
        projects.
      </p>

      <div className="card p-4 mt-3">
        <h5>Example</h5>

        {error ? <p className="onboarding-error">{error}</p> : commissionRate === null ? <p>Loading compensation details...</p> : (
          <>
            <p>Website Project: {money(PROJECT_AMOUNT)}</p>
            <p>Commission Rate: {percent(commissionRate)}</p>

            <p>Client pays first deposit of {money(PAYMENT_AMOUNT)} - You earn {money(example.firstPayment)}.</p>

            <p>Client pays final {money(PAYMENT_AMOUNT)} - You earn another {money(example.finalPayment)}.</p>

            <p>
              <strong>Total Earnings: {money(example.total)}</strong>
            </p>
          </>
        )}
      </div>

      <p className="mt-4">There is no limit to how much you can earn.</p>

      <div className="actions">
        <button
          className="btn btn-secondary"
          onClick={() => navigate("/onboarding")}
        >
          Back
        </button>

        <button
          className="btn btn-primary"
          onClick={() => navigate("/onboarding/stripe")}
        >
          Continue
        </button>
      </div>
    </div>
  );
}